import React from 'react';
import { useSyncAmbulanceStatusFromDevices } from '../hooks/useSyncAmbulanceStatusFromDevices';

/** Runs ambulance available/off_duty sync globally for authenticated tenant users. */
const AmbulanceStatusSyncRunner: React.FC = () => {
  useSyncAmbulanceStatusFromDevices();
  return null;
};

export default AmbulanceStatusSyncRunner;
